/**
 * 邀请码配置
 *
 * 邀请码验证通过后端 API 完成，前端不存储有效邀请码列表
 */

// localStorage key
const STORAGE_KEY = 'enpass_invite_code';

/**
 * 通过后端 API 验证邀请码
 */
export async function validateInviteCode(code: string): Promise<{ valid: boolean; error?: string }> {
  try {
    const response = await fetch('/.netlify/functions/invite', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code.trim().toUpperCase() }),
    });

    const data = await response.json() as { valid: boolean; error?: string };
    return data;
  } catch {
    return { valid: false, error: '网络连接失败，请稍后重试' };
  }
}

/**
 * 检查用户是否已通过邀请码验证（本地缓存）
 */
export function hasValidInviteCode(): boolean {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored !== null && stored.length > 0;
}

/**
 * 保存邀请码（验证通过后调用）
 */
export function saveInviteCode(code: string): void {
  localStorage.setItem(STORAGE_KEY, code.trim().toUpperCase());
}

/**
 * 清除已保存的邀请码
 */
export function clearInviteCode(): void {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * @deprecated 使用 validateInviteCode 代替
 * 保留兼容性，始终返回 false，强制使用后端验证
 */
export function isValidInviteCode(_code: string): boolean {
  console.warn('isValidInviteCode is deprecated, use validateInviteCode instead');
  return false;
}
